import React from 'react';
import { InternalProvider } from '../../../../util/InternalProvider';
import { ModalHeader, ModalMain, ModalTitle, ModalScrollContainer, ModalSubTitle, } from './elements';
export var DefaultModal = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, titleFontSize = _a.titleFontSize, _c = _a.subTitle, subTitle = _c === void 0 ? '' : _c, children = _a.children, _d = _a.stickyHeader, stickyHeader = _d === void 0 ? true : _d;
    return (React.createElement(InternalProvider, null,
        React.createElement(ModalScrollContainer, { stickyHeader: stickyHeader },
            React.createElement(ModalHeader, null,
                React.createElement("div", { id: "dialog-title" },
                    React.createElement(ModalTitle, { fontSize: titleFontSize }, title),
                    React.createElement(ModalSubTitle, null, subTitle))),
            React.createElement(ModalMain, { stickyHeader: stickyHeader },
                React.createElement("div", { id: "dialog-content" }, children)))));
};
